import React from 'react';
import { connect } from 'react-redux';

import { isBrowser, isSuperUser } from '../lib/utils';
import { openLoginModal } from '../redux/actions/authActions';
import { openOverviewModal, setActiveEditor } from '../redux/actions/trekOverviewActions';

// editor with trekEdit Permissions
export default function withTrekEditPermission(WrappedComp) {
  const mapStateToProps = ({ user, selectedTrek }, { skipPermissionCheck }) => {
    const isLoggedIn = Boolean(user.userId);
    const isDraft = selectedTrek.trek.is_draft && selectedTrek.trek.is_draft;
    // const isPublic = selectedTrek.trek.is_public && (selectedTrek.trek.is_public);
    const isTemplate = selectedTrek.trek.is_template && selectedTrek.trek.is_template;
    const isOwner = selectedTrek.trek && selectedTrek.trek.is_owner;
    const isFollower = selectedTrek.trek && selectedTrek.trek.is_follower;
    const isFrozen = selectedTrek.trek && selectedTrek.trek.is_frozen;

    return {
      isLoggedIn,
      isTemplate,
      isDraft,
      isOwner,
      isFrozen,
      isFollower,
      skipPermissionCheck,
    };
  };

  const mapDispatchToProps = (dispatch, ownProps) => {
    const { editorName, openModal } = ownProps;
    const openEditorModal = () => dispatch(openOverviewModal({ component: editorName }));
    const openInlineEditor = () => dispatch(setActiveEditor({ component: editorName }));
    return {
      openLoginModal: () => dispatch(openLoginModal()),
      activateEditor:
        openModal || (isBrowser() && window.innerWidth < 600)
          ? openEditorModal
          : openInlineEditor,
      openMessageModal: ({ component }) => dispatch(openOverviewModal({ component })),
    };
  };

  const Editor = function(props) {
    const {
      isDraft,
      isOwner,
      isLoggedIn,
      isTemplate,
      // isFollower,
      activateEditor,
      openMessageModal,
      skipPermissionCheck,
    } = props;

    const showMessage = () => {
      // if not logged in
      if (!isLoggedIn) {
        if (isTemplate)
          return openMessageModal({
            component: 'LoginToUseTemplate',
          });
        if (isDraft) return openMessageModal({ component: 'LoginToJoin' });

        return openMessageModal({ component: 'LoginToJoin' });
        // openModal({ message: '0L-0T' });
      }
      // if you are the owner
      if (isOwner) {
        if (isTemplate)
          return openMessageModal({
            component: 'You are HG. TEMPLATE EDITOR UI - activateEditor',
          });
      }
      // if not the owner
      if (isTemplate) return openMessageModal({ component: 'UseTemplate' });

      // if (isFollower) return openMessageModal({ component: 'OnlyOwnerCanEdit', });
      // if (isMemeber) return openMessageModal({ component: "OnlyOwnerCanEdit" });
      // when draft is false and template is false == is a published tek
      //
      return openMessageModal({ component: 'OnlyOwnerCanEdit' });
    };

    const runThis =
      isOwner || isSuperUser() || skipPermissionCheck ? activateEditor : showMessage;

    return <WrappedComp onEditPress={runThis} {...props} />;
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(Editor);
}



// WEBPACK FOOTER //
// ./src/HOCs/withTrekEditPermission.jsx